export const testimonials = [
  {
    id: 1,
    name: 'Martin Kováč',
    company: 'CEO, TechFlow s.r.o.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20slovak%20businessman%20portrait%20photo%20headshot%20confident%20smile%20dark%20hair%2C%20clean%20white%20background%2C%20corporate%20style%20photography%2C%20high%20quality%2C%20sharp%20focus&width=200&height=200&seq=avatar1&orientation=squarish',
    rating: 5,
    text: 'Boostio nám kompletne pretransformovalo online prítomnosť. Organická návštevnosť vzrástla o 280% a konverzie sa zdvojnásobili. Profesionálny tím, výnimočné výsledky.',
    metric: '+280% návštevnosť',
  },
  {
    id: 2,
    name: 'Jana Horáčková',
    company: 'Marketingová riaditeľka, Bella Mode',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20slovak%20businesswoman%20portrait%20photo%20headshot%20confident%20smile%20brown%20hair%2C%20clean%20white%20background%2C%20corporate%20style%20photography%2C%20high%20quality%2C%20sharp%20focus&width=200&height=200&seq=avatar2&orientation=squarish',
    rating: 5,
    text: 'Náš e-shop po redesigne a marketingovej kampani od Boostio zaznamenal rekordné tržby. Tím rozumie biznisu a nepredáva len sľuby, ale reálne výsledky.',
    metric: '+3× obrat e-shopu',
  },
  {
    id: 3,
    name: 'Peter Sloboda',
    company: 'Majiteľ, AutoServis Premium',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20middle-aged%20slovak%20man%20portrait%20photo%20headshot%20friendly%20smile%20gray%20hair%2C%20clean%20white%20background%2C%20corporate%20photography%2C%20high%20quality%2C%20sharp%20focus&width=200&height=200&seq=avatar3&orientation=squarish',
    rating: 5,
    text: 'Vďaka Google Ads kampaniam od Boostio sa naša servisná linka zaplnila na mesiace dopredu. Výborná komunikácia, transparentné reporty a reálne výsledky.',
    metric: '+190% nových zákazníkov',
  },
  {
    id: 4,
    name: 'Lucia Benková',
    company: 'Zakladateľka, NutriLife',
    avatar: 'https://readdy.ai/api/search-image?query=young%20professional%20slovak%20woman%20portrait%20photo%20headshot%20bright%20smile%20blonde%20hair%2C%20clean%20light%20background%2C%20modern%20corporate%20photography%2C%20high%20quality&width=200&height=200&seq=avatar4&orientation=squarish',
    rating: 5,
    text: 'So správou sociálnych sietí sme dosiahli 15 000 nových sledovateľov za 6 mesiacov. Obsah je vždy kvalitný, kreatívny a na mieru nášmu publiku.',
    metric: '+15 000 sledovateľov',
  },
  {
    id: 5,
    name: 'Rastislav Mináč',
    company: 'CTO, LogiSoft a.s.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20tech%20guy%20portrait%20headshot%20confident%20smile%20dark%20beard%20glasses%2C%20clean%20background%2C%20corporate%20style%20photography%2C%20high%20quality%20sharp%20focus&width=200&height=200&seq=avatar5&orientation=squarish',
    rating: 5,
    text: 'CRM systém vyvinutý Boostio nám ušetril desiatky hodín týždenne. Integrácia so všetkými nástrojmi prebehla bez problémov. Odporúčam každej firme.',
    metric: '40h/týždeň ušetrených',
  },
  {
    id: 6,
    name: 'Zuzana Pálková',
    company: 'Riaditeľka, KráľovskáSpa',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20professional%20slovak%20woman%20portrait%20headshot%20warm%20smile%20dark%20hair%2C%20clean%20bright%20background%2C%20professional%20photography%2C%20high%20quality&width=200&height=200&seq=avatar6&orientation=squarish',
    rating: 5,
    text: 'Boostio nám vytvorilo krásnu webstránku s rezervačným systémom. Zákazníci chvália jednoduchosť a my máme konečne poriadok v rezerváciách. Skvelá práca!',
    metric: '+65% online rezervácií',
  },
];
